<template>
  <!-- <van-nav-bar title="订餐列表"></van-nav-bar> -->
  <div class="top">
    <div class="container">
      <div style="height: 10px"></div>
      <div class="student_info">
        <div class="info">
          <van-button
            class="changeBtn"
            plain
            size="small"
            type="primary"
            @click="toOrderList"
            color="#1989fa"
            >订单</van-button
          >
          <van-button
            class="changeBtn"
            plain
            size="small"
            type="primary"
            @click="toChild"
            color="#1989fa"
            >切换</van-button
          >

          <img src="../assets/default_profile.png" />
          <div class="student_desc">
            <span>{{ child_name }}</span>
            <span>{{ school_name }}</span>
            <span>{{ class_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <van-empty v-if="listSize == 0" description="暂无内容" />
  <div v-if="listSize > 0" style="margin-bottom: 40px">
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="2"
      @load="onLoad"
    >
      <van-cell-group
        inset
        v-for="item in list"
        :key="item.payment_id"
        style="margin-top: 10px"
        @click="toDetail(item)"
      >
        <van-cell :title="item.catering_company" />
        <van-cell :title="item.cost_name" />
        <van-cell :title="'订单金额: ¥' + item.cost" />
        <van-cell :title="'订餐截止: ' + item.end_date" value="查看详情>>" />
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { Toast } from "vant";
import { useRouter } from "vue-router";
import api from "../service/api";

export default {
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    // const route = useRoute(); //获取到值
    const router = useRouter(); //路由传值
    const child_id = ref("");
    const child_name = ref("");
    const school_name = ref("");
    const class_name = ref("");
    const listSize = ref(1);

    onMounted(() => {
      if (getQuery("child_id")) {
        localStorage.setItem("childId", getQuery("child_id"));
        localStorage.setItem("childName", getQuery("child_name"));
        localStorage.setItem("schoolName", getQuery("school_name"));
        localStorage.setItem("className", getQuery("class_name"));
      }
      child_id.value = localStorage.getItem("childId");
      child_name.value = localStorage.getItem("childName");
      school_name.value = localStorage.getItem("schoolName");
      class_name.value = localStorage.getItem("className");
    });

    const toDetail = (item) => {
      router.push({
        path: "/detail",
        query: {
          charge_restaurant_id: item.charge_restaurant_id,
          companyName: item.catering_company,
        },
      });
    };

    const toChild = () => {
      // history.pushState({}, "", `https://${window.location.host}`);
      router.push({
        path: "/child",
      });
    };
    const toOrderList = () => {
      router.push({
        path: "/orderList",
      });
    };
    const onLoad = () => {
      finished.value = false;
      loading.value = true;
      api
        .getRestaurantList({
          child_id: child_id.value,
        })
        .then((res) => {
          if (res.data.code == 34504) {
            let result = res.data.result;
            let companyList = result;
            for (let i = 0; i < companyList.length; i++) {
              list.value.push(companyList[i]);
            }
            listSize.value = list.value.length;
            // 加载状态结束
            loading.value = false;

            // 数据全部加载完成
            finished.value = true;
          } else {
            listSize.value = 0;
            finished.value = true;
          }
        })
        .catch((err) => {
          finished.value = true;
          listSize.value = 0;
          Toast(err.message);
        });
    };

    function getQuery(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURI(pair[1]);
        }
      }
      return false;
    }

    return {
      list,
      onLoad,
      loading,
      finished,
      toDetail,
      toChild,
      child_id,
      child_name,
      school_name,
      class_name,
      listSize,
      toOrderList,
    };
  },
};
</script>

<style lang="less">
.top {
  position: sticky;
  top: 1px;
  z-index: 99;
  .container {
    height: 140px;
    background-color: #f2f2f2;
    .student_info {
      width: 94%;
      margin: 0 auto;
      height: 120px;
      border-radius: 6px;
      background-color: #1989fa;
      box-shadow: 0 2px 5px #1989fa;

      .info {
        display: block;
        width: 92%;
        height: 120px;
        margin: 0 auto;
        .changeBtn {
          float: right;
          margin-top: 20px;
          margin-right: 10px;
        }

        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-top: 4px;
          display: inline-block;
          overflow: hidden;
          margin-top: 30px;
        }
        .student_desc {
          display: inline-block;
          margin-left: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #fff;
          span {
            display: block;
            color: #fff;
            font-size: 14px;
            padding: 2px 0;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
